export default __webpack_public_path__ + "static/media/admin-background.5e664491.png";